import { useState, useCallback, useMemo, useEffect } from 'react';

interface CalendarTimeItemHookProps {
  reserveItemList: {
    [date_block: string]: Date[];
  }[];
  reserveDate: Date;
}
export const useCalendarTimeItem = ({
  reserveItemList,
  reserveDate,
}: CalendarTimeItemHookProps) => {
  const [timeSelect, setTimeSelect] = useState('');
  useEffect(() => {
    setTimeSelect((prev) =>
      reserveDate instanceof Date && !isNaN(reserveDate.getTime())
        ? `${padding(reserveDate.getHours())}:${padding(
            reserveDate.getMinutes(),
          )}:00`
        : prev,
    );
  }, [reserveDate]);

  const padding = useCallback((value: number) => {
    const zeroPad = 2;
    return value.toString().padStart(zeroPad, '0');
  }, []);
  const toDateText = useCallback((date: Date) => {
    const offset = 1;
    return `${date.getFullYear()}-${padding(
      date.getMonth() + offset,
    )}-${padding(date.getDate())}`;
  }, []);

  const handleChangeTime = useCallback(
    (time: Date) =>
      setTimeSelect(
        `${padding(time.getHours())}:${padding(time.getMinutes())}:00`,
      ),
    [setTimeSelect],
  );

  const timeList = useMemo(() => {
    if (reserveDate instanceof Date && !isNaN(reserveDate.getTime())) {
      const keyName = toDateText(reserveDate);
      const findItem = reserveItemList.find((item) =>
        Object.keys(item).includes(keyName),
      );
      const timeList = findItem
        ? findItem[keyName].reduce((list, item) => {
            const dateItem = new Date(item);
            const timeListItem: CalendarTimeItemType = {
              dateLabel: `${padding(dateItem.getHours())}:${padding(
                dateItem.getMinutes(),
              )}`,
              onClick: () => handleChangeTime(dateItem),
              selectStyle:
                !!(dateItem.getHours() === reserveDate.getHours()) &&
                !!(dateItem.getMinutes() === reserveDate.getMinutes())
                  ? 'time-item select'
                  : 'time-item',
            };
            list.push(timeListItem);
            return list;
          }, [] as CalendarTimeItemType[])
        : ([] as CalendarTimeItemType[]);
      return timeList;
    } else {
      return [] as CalendarTimeItemType[];
    }
  }, [reserveItemList, reserveDate]);
  return {
    timeSelect,
    timeList,
  };
};

export type CalendarTimeItemType = {
  dateLabel: string;
  selectStyle: string;
  onClick: () => void;
};
